import React, { useEffect } from "react";
import RealMap from "../../Maps/RealMap";
import { Maximize2, X } from "lucide-react";
import useDriverTeams from "../../../Sevices/Driver Api/useDriverTeams";


export default function MapPanel({
  tasks = [],
  drivers = [],
  isMapZoomed,
  setIsMapZoomed,
}) {
  const { teams, fetchDriverTeams } = useDriverTeams();

  useEffect(() => {
    fetchDriverTeams();
  }, [fetchDriverTeams]);

  return (
    <>
      {/* -------- MINI MAP -------- */}
      {!isMapZoomed && (
        <div className="w-full px-3 mt-2 relative z-[10]">
          <div className="h-[240px] w-full border rounded-md relative overflow-hidden bg-white shadow-sm">
            <button
              onClick={() => setIsMapZoomed(true)}
              className="absolute bottom-3 right-3 bg-white text-gray-900 p-2 rounded-lg shadow-lg z-[999]"
            >
              <Maximize2 size={18} />
            </button>

            <RealMap
              Task={tasks}
              drivers={drivers}
              teams={teams}
              showSearch={false}
            />
          </div>
        </div>
      )}

      {/* -------- FULL SCREEN MAP -------- */}
      {isMapZoomed && (
        <div className="fixed inset-0 bg-black/60 z-[99999]">
          <div className="w-full h-full bg-white relative">
            <button
              onClick={() => setIsMapZoomed(false)}
              className="absolute top-4 right-4 bg-red-500 text-white p-2 rounded-lg z-[100000]"
            >
              <X size={18} />
            </button>

            <RealMap
              Task={tasks}
              drivers={drivers}
              teams={teams}
              showSearch={true}
            />
          </div>
        </div>
      )}
    </>
  );
}